/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TableCell } from "@material-ui/core";
import RoleRow from "./RoleRow";
import { skaleWhite } from "config/UpduoColors";
import MemberTableBase from "../MemberTableBase";

enum Permission {
  View = "view",
  Full = "full",
}

const ROLES = [
  {
    role: "Participant",
    permissions: {
      matching: Permission.Full,
    },
  },
  {
    role: "Manager",
    permissions: {
      matching: Permission.Full,
      dashboard: Permission.Full,
      roles: Permission.View,
    },
  },
  {
    role: "Content Editors",
    permissions: {
      matching: Permission.Full,
      dashboard: Permission.Full,
      content: Permission.Full,
      topics: Permission.Full,
      notifications: Permission.Full,
      roles: Permission.View,
    },
  },
  {
    role: "Admin",
    permissions: {
      matching: Permission.Full,
      dashboard: Permission.Full,
      content: Permission.Full,
      topics: Permission.Full,
      notifications: Permission.Full,
      roles: Permission.Full,
    },
  },
];

const PERMISSIONS = [
  { permission: "matching", display: "Matching" },
  { permission: "dashboard", display: "Dashboard" },
  { permission: "content", display: "Content" },
  { permission: "topics", display: "Topics" },
  { permission: "notifications", display: "Notifications" },
  { permission: "roles", display: "Member Roles" },
];

export default function RolesTable() {
  const cellStyle = {
    fontSize: 16,
    fontWeight: 500,
    fontFamily: "ObjectSans-Medium",
    textAlign: "center" as const,
    backgroundColor: skaleWhite,
  };

  const columnHeaders = [
    <TableCell key={"blank"} style={{ backgroundColor: skaleWhite }} />,
    PERMISSIONS.map(({ permission, display }) => (
      <TableCell key={permission} style={cellStyle}>
        {display}
      </TableCell>
    )),
  ];

  return (
    <MemberTableBase
      headers={columnHeaders}
      body={ROLES.map((role) => (
        <RoleRow
          key={role.role}
          role={role}
          permissions={PERMISSIONS.map(({ permission }) => permission)}
        />
      ))}
    />
  );
}
